import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import type { SettingsV4Get } from './SettingsGet.types.tsx';

export const getAnnouncementBannerSettingsV4 = async (): Promise<SettingsV4Get> => {
	try {
		return await performGetRequest('/rest/internal/4/announcement-banner');
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// 403 - banner is set to private and user is anonymous
		if (error.statusCode === 403) {
			return {
				content: '',
				bgColor: 'grey',
				isEnabled: false,
				isDismissable: false,
				visibility: 'private',
				hashId: '',
			};
		}

		fireErrorAnalytics({
			meta: {
				id: 'settingsV4Get',
				packageName: 'jiraAdminPagesSystemUiAnnouncementBannerResources',
				teamName: 'jira-cosmos',
			},
			error,
		});
		throw error;
	}
};
